// ダッシュボード(performer 画面)
// 現在の配信状態 + 主要アクション(配信を開始 / 履歴へ)

import { Link } from 'react-router-dom';
import { useCurrentSession, SESSION_STATE_LABELS } from '../api/sessions';
import { useAuth } from '../auth/AuthContext';
import { AppLayout } from '../components/AppLayout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';

export function DashboardPage() {
  const { performer } = useAuth();
  const currentQuery = useCurrentSession();
  const active = currentQuery.data;

  return (
    <AppLayout
      title="ダッシュボード"
      description={`ようこそ、${performer?.display_name ?? ''} さん`}
    >
      <Card title="現在の配信">
        {currentQuery.isLoading ? (
          <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>確認中…</p>
        ) : active ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <div>
              <p style={{ margin: '0 0 4px', fontSize: '13px' }}>
                配信中:{SESSION_STATE_LABELS[active.state]}
              </p>
              <p style={{ margin: 0, fontSize: '11px', color: 'var(--color-text-tertiary)' }}>
                セッション {active.ulid}
              </p>
            </div>
            <div style={{ minWidth: 160 }}>
              <Link to="/streaming">
                <Button variant="secondary">配信画面へ</Button>
              </Link>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>
              現在配信していません。
            </p>
            <div style={{ minWidth: 160 }}>
              <Link to="/streaming">
                <Button>配信を開始</Button>
              </Link>
            </div>
          </div>
        )}
      </Card>

      <Card title="クイックアクセス">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ minWidth: 180 }}>
            <Link to="/streaming-profiles">
              <Button variant="secondary">配信先プロファイル</Button>
            </Link>
          </div>
          <div style={{ minWidth: 180 }}>
            <Link to="/sessions">
              <Button variant="secondary">配信履歴</Button>
            </Link>
          </div>
          <div style={{ minWidth: 180 }}>
            <Link to="/settings">
              <Button variant="secondary">アカウント設定</Button>
            </Link>
          </div>
        </div>
      </Card>
    </AppLayout>
  );
}
